import React, { useEffect, useState } from "react";

export default function AddPartnerModal({
  isEdit = false,
  show,
  onClose,
  onSave,
  isLoading,
  editPartner,
}) {
  const [form, setForm] = useState({
    id: "",
    name: "",
    contact: "",
    cnic: "",
    address: "",
    openingBalance: "",
    addDate: "",
    profitRatio: "",
    ownershipType: "plzSelect",
  });

  useEffect(() => {
    if (isEdit) {
      const object = {
        id: editPartner?._id,
        name: editPartner?.name,
        contact: editPartner?.contact,
        cnic: editPartner?.cnic,
        address: editPartner?.address,
        openingBalance: editPartner?.openingBalance,
        addDate: editPartner?.addDate,
        profitRatio: editPartner?.profitRatio,
        ownershipType: editPartner?.ownershipType,
        isEdit,
      };

      setForm(object);
    }
  }, [isEdit]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.id]: e.target.value,
    });
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      alert("Partner name is required");
      return;
    }

    if (onSave) {
      const response = await onSave(form);

      if (response.success) {
        setForm({
          name: "",
          contact: "",
          cnic: "",
          address: "",
          openingBalance: "",
          addDate: "",
          profitRatio: "",
          ownershipType: "plzSelect",
        });

        onClose();
      } else {
        alert(response.error);
      }
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
    >
      <div
        className="modal-dialog modal-dialog-scrollable"
        style={{ marginTop: "6rem" }}
      >
        <div className="modal-content">
          {/* HEADER */}

          <div className="modal-header">
            <h1 className="modal-title fs-5">
              {isEdit ? "Edit" : "Add"} Partner
            </h1>

            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          {/* BODY */}

          <div className="modal-body">
            <div className="row">
              <div className="col-6">
                <label>Partner Name</label>
                <input
                  type="text"
                  id="name"
                  className="form-control"
                  placeholder="KW - Partner"
                  value={form.name}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6">
                <label>Contact</label>
                <input
                  type="tel"
                  id="contact"
                  className="form-control"
                  placeholder="0333 3911111"
                  value={form.contact}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6">
                <label>CNIC</label>
                <input
                  type="text"
                  id="cnic"
                  className="form-control"
                  placeholder="45505-1111111-1"
                  value={form.cnic}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6">
                <label>Address</label>
                <input
                  type="text"
                  id="address"
                  className="form-control"
                  placeholder="Optional"
                  value={form.address}
                  onChange={handleChange}
                />
              </div>

              {!isEdit && (
                <div className="col-6">
                  <label>Opening Balance</label>
                  <input
                    type="number"
                    id="openingBalance"
                    className="form-control"
                    placeholder="50,000"
                    value={form.openingBalance}
                    onChange={handleChange}
                  />
                </div>
              )}

              {!isEdit && (
                <div className="col-6">
                  <label>Partner Add Date</label>
                  <input
                    type="datetime-local"
                    id="addDate"
                    className="form-control"
                    value={form.addDate}
                    onChange={handleChange}
                  />
                </div>
              )}

              <div className="col-6">
                <label>Profit Ratio</label>
                <input
                  type="number"
                  id="profitRatio"
                  className="form-control"
                  placeholder="20%"
                  value={form.profitRatio}
                  onChange={handleChange}
                />
              </div>

              <div className="col-6">
                <label>Ownership Type</label>
                <select
                  id="ownershipType"
                  className="form-control"
                  value={form.ownershipType}
                  onChange={handleChange}
                >
                  <option value="plzSelect">--- SELECT ---</option>
                  <option value="activePartner">Active Partner</option>
                  <option value="silentPartner">Silent Partner</option>
                  <option value="sleepPartner">Sleep Partner</option>
                </select>
              </div>
            </div>
          </div>

          {/* FOOTER */}

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
